// extracted by mini-css-extract-plugin
export default {"text":"ResendCode_text__ZdR-0","pointer":"ResendCode_pointer__qP+vI","error":"ResendCode_error__2rB5G"};